import { Box, Link, Stack, Typography } from "@mui/material";
import "./MyPersonalData.scss";
import { useContext, useEffect, useState } from "react";
import theme from "../../muiTheme";
import {
  PersonalData,
  PersonalDataInformation,
} from "../../core/models/myPersonalData/myPersonalData.model";
import { useTranslation } from "react-i18next";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import { FormattedOwnerData } from "../../core/models/ownerData/ownerData.model";

interface MyPersonalDataProps {
  handleGoBackClick?: () => void;
}

const MyPersonalData = ({ handleGoBackClick }: MyPersonalDataProps) => {
  const { t } = useTranslation();
  const { ownerData } = useContext(TotalEnergiesContext);
  const [personalData, setPersonalData] = useState<PersonalData>({
    name: "",
    surname: "",
    identification: "",
  });

  useEffect(() => {
    getFormattedOwnerData(ownerData);
  }, [ownerData]);

  const personalDataInformation: PersonalDataInformation[] = [
    {
      id: "name",
      label: "Nombre",
    },
    {
      id: "surname",
      label: "Apellido",
    },
    {
      id: "identification",
      label: "NIF / DNI",
    },
  ];

  const getFormattedOwnerData = (ownerData: FormattedOwnerData | null) => {
    if (ownerData) {
      const {
        isAdministrator,
        firstClientSurname,
        secondClientSurname,
        clientName,
        clientIdentification,
        administratorName,
      } = ownerData;

      if (isAdministrator) {
        setPersonalData((prevPersonalData) => ({
          ...prevPersonalData,
          name: administratorName,
        }));
        return;
      }

      setPersonalData({
        name: clientName,
        surname: `${firstClientSurname}${
          secondClientSurname && " "
        }${secondClientSurname}`,
        identification: clientIdentification,
      });
    }
  };

  return (
    <Stack
      className="my-personal-data"
      sx={{ color: theme.palette.grey[900], paddingY: 4, paddingX: "20px" }}
    >
      <Link
        className="my-personal-data__button"
        component="button"
        onClick={handleGoBackClick}
        underline="none"
        sx={{ marginBottom: { xs: "56px", lg: 5 }, paddingY: "14px" }}
      >
        {" "}
        <Typography
          component="span"
          className="t-icon-long-arrow-left"
          aria-hidden="true"
          paddingRight={"10px"}
        />
        {t("Botón volver")}
      </Link>
      <Typography
        component="h3"
        variant="h3"
        sx={{ paddingBottom: { xs: "40px", headerMobile: "60px" } }}
      >
        <span
          className="t-icon-user brand-red"
          style={{ paddingRight: "15px" }}
        />{" "}
        {t("Header.Perfil.Datos Personales")}
      </Typography>
      {personalDataInformation.map(({ id, label }) => (
        <Box key={id} sx={{ marginBottom: { xs: 3, headerMobile: "30px" } }}>
          <Typography component="h4" variant="body1" className="brand-gray">
            {t(label)}
          </Typography>
          <Typography component="p" variant="subtitle2">
            {personalData[id] || "-"}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default MyPersonalData;
